import { EDGE_REGION_HINT_HEADER } from '@atlassian/search-common/get-edge-region-hint';

/**
 * Arguments for {@link preloadQuery}. Mirrors the persisted-query POST contract
 * the search page uses on mount, but invoked directly (no Relay environment).
 */
export type PreloadQueryArgs = {
	persistedId: string;
	operationName: string;
	queryVariables: Record<string, unknown>;
	edgeRegionHint: string | undefined;
	aggAbsoluteUrl: string;
};

/**
 * Fire a persisted-query POST against AGG so the response is warmed in the
 * backend cache before the search page mounts.
 *
 * Best-effort and fire-and-forget — rejections are swallowed so warm-up
 * failures don't break navigation. Returns the underlying promise so callers
 * can opt in to awaiting (tests).
 */
export const preloadQuery = ({
	persistedId,
	operationName,
	queryVariables,
	edgeRegionHint,
	aggAbsoluteUrl,
}: PreloadQueryArgs): Promise<void> => {
	return fetch(`${aggAbsoluteUrl}/pq/${persistedId}?operation=${operationName}`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			...(edgeRegionHint ? { [EDGE_REGION_HINT_HEADER]: edgeRegionHint } : {}),
		},
		body: JSON.stringify({
			operationName,
			variables: queryVariables,
		}),
	})
		.then(() => undefined)
		.catch(() => {
			// Swallow — warm-up is best-effort.
		});
};
